// Cores do menu lateral, usadas no selo dos ícones (Sidenav) e nas abas abertas (SystemWrapper).

// Fundo do menu lateral (assets/theme*/components/sidenav.js)
export const COR_MENU = "#a86b32";

// Cor de cada seção do menu (key da rota de primeiro nível). O ícone fica branco sobre o selo
// (contraste de 4,5:1 a 10,4:1 com estas cores).
export const CORES_SECAO = {
  monitoria: "#00838F",
  legalConsult: "#1565C0",
  cobranca: "#2E7D32",
  maladireta: "#827717",
  relatorios_menu: "#6A1B9A",
  cadastro_geral: "#AD1457",
  processes: "#283593",
  tools: "#455A64",
  suporte: "#00695C",
  robo: "#C62828",
};

/** Mapa key da tela -> cor da seção do menu a que ela pertence (inclui os submenus aninhados). */
export function mapearCoresDasTelas(rotas) {
  const mapa = {};
  const percorrer = (itens, cor) => (itens || []).forEach((item) => {
    if (item.key && !(item.key in mapa)) mapa[item.key] = cor;
    percorrer(item.collapse, cor);
  });
  (rotas || []).forEach((secao) => {
    const cor = CORES_SECAO[secao.key];
    if (cor) {
      mapa[secao.key] = cor;
      percorrer(secao.collapse, cor);
    }
  });
  return mapa;
}

/** "#RRGGBB" -> "rgba(r, g, b, opacidade)". */
export function comOpacidade(hex, opacidade) {
  const [r, g, b] = [1, 3, 5].map((i) => parseInt(hex.substr(i, 2), 16));
  return `rgba(${r}, ${g}, ${b}, ${opacidade})`;
}

/** Mistura a cor com branco (fracao 0..1): deixa os tons escuros visíveis em fundo escuro. */
export function clarear(hex, fracao) {
  const canal = (i) => {
    const v = parseInt(hex.substr(i, 2), 16);
    return Math.round(v + (255 - v) * fracao).toString(16).padStart(2, "0");
  };
  return `#${canal(1)}${canal(3)}${canal(5)}`;
}
